function initLazyLoadSliderVideos()
{
    var desktopVideos = document.querySelectorAll("video.video-lazy.hp-desktop-only");
    var mobileVideos = document.querySelectorAll("video.video-lazy.hp-mobile-only");
    var videos;

    if (window.innerWidth > 767)
    {
        videos = desktopVideos;
    }
    else
    {
        videos = mobileVideos;
    }

    for (var i = 0; i < videos.length; i++)
    {
        var video = videos[i];
        var source = video.querySelector("source");
        var videoWrapper = video.closest(".we-video-wrapper");

        if (!source.src && source.dataset.src)
        {
            source.src = source.dataset.src;
            videoWrapper.classList.remove("hidden");
            video.load();
        }

        if (source.src)
        {
            videoWrapper.classList.remove("hidden");
        }
        else
        {
            videoWrapper.classList.add("hidden");
        }

        tryAutoplay(video);
    }
}

function tryAutoplay(video)
{
    if (window.innerWidth < 968)
    {
        video.muted = true;
        if (video.paused)
        {
            video.play().catch(function(error)
            {
                console.error("Error trying to autoplay video:", error);
            });
        }
    }
}

initLazyLoadSliderVideos();

window.addEventListener("resize", initLazyLoadSliderVideos);

window.addEventListener("scroll", function()
{
    var mobileVideos = document.querySelectorAll("video.video-lazy.hp-mobile-only");
    mobileVideos.forEach(tryAutoplay);
});
